import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateClinicProfileInfo, getClinicInfo } from "../../../store/slices/clinicSlice";

const AllPdf = () => {
  const dispatch = useDispatch();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const clinic = clinicInfo && clinicInfo.length > 0 ? clinicInfo[0] : {};
  const selectedReport = clinic?.reportName || "default";
  const token = useSelector((state) => state.auth?.token); 

const handleChange = (e) => {
  const reportName = e.target.value;
  console.log("handleChange fired, new reportName:", reportName);

  if (!clinic?.userId) {
    console.warn("No clinic userId found!");
    return;
  }

  dispatch(
    updateClinicProfileInfo({
      formData: { userId: clinic.userId, reportName },
      token,
    })
  ).then(() => {
    dispatch(getClinicInfo({ userId: clinic.userId, token }));
  });
};



  const reportOptions = [
    { value: "default", label: "Default" },
    // { value: "tatareport", label: "Tata Report" },
    // { value: "curewellreport", label: "Curewell Report" },
  ];

  return (
    <div>
      <h3>Other Settings</h3>
      <div>
        {reportOptions.map((option) => (
          <label key={option.value} style={{ display: "block", marginBottom: "8px" }}>
            <input
              type="radio"
              name="reportType"
              value={option.value}
              checked={selectedReport === option.value}
              onChange={handleChange}
            />
            {option.label}
          </label>
        ))}
      </div>
    </div>
  );
};

export default AllPdf;
